import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

import {ChargeCodeProperty, ProjectChargeCode} from "app/shared/classes/charge-code";
import {ChargeCodeService} from "app/shared/services/charge-code.service";
import {Validation} from "@app/shared/enums/validation.enum";

@Component({
  selector: "app-charge-code-auto-complete",
  templateUrl: "./charge-code-auto-complete.component.html",
  styleUrls: ["./charge-code-auto-complete.component.css"]
})
export class ChargeCodeAutoCompleteComponent implements OnInit {

  Validation: typeof Validation = Validation;

  chargeCodeOptions: ProjectChargeCode[];
  selectedChargeCode: ProjectChargeCode = new ProjectChargeCode();

  private _chargeCode: ProjectChargeCode;

  defaultProperties = [
    ChargeCodeProperty.ChargeNumber,
    ChargeCodeProperty.Name,
    ChargeCodeProperty.PayTypeCode,
    ChargeCodeProperty.ProjectLaborCategory
  ];
  _properties = this.defaultProperties;

  @Input()
  set chargeCode(value: ProjectChargeCode) {
    if (value) {
      this._chargeCode = value;
      Object.assign(this.selectedChargeCode, value);
    } else {
      console.log("charge-code-auto-complete:set chargeCode = undefind value");
    }
  }

  get chargeCode(): ProjectChargeCode {
    return this._chargeCode;
  }

  @Input()
  set properties(value: ChargeCodeProperty[]) {
    if (value) {
      this._properties = value;
    } else {
      console.log("charge-code-auto-complete:set properties = undefind value");
      this._properties = this.defaultProperties;
    }
  }

  get properties(): ChargeCodeProperty[] {
    return this._properties;
  }

  @Output() handler: EventEmitter<ProjectChargeCode> = new EventEmitter();
  @Output() cancelHandler: EventEmitter<any> = new EventEmitter();


  constructor(private ccDataService: ChargeCodeService) {
  }

  ngOnInit() {
  }

  searchChargeCode(event) {
    this.ccDataService.searchChargeCode(event.query).subscribe(res => {
      this.chargeCodeOptions = res.list;
    });
  }

  onSelectChargeCode() {
    console.log(
      "charge-code-auto-complete:onSelectChargeCode: selectedChargeCode and chargeCode. this.chargeCode will be set to this.selectedChargeCode"
    );
    console.log(this.selectedChargeCode);
    console.log(this.chargeCode);
    if (this.chargeCode) {
      Object.assign(this.chargeCode, this.selectedChargeCode);
      this.handler.emit(this.chargeCode);
    } else {
      console.warn(
        "The input chargeCode is null, thus could not be set. Handler needs to take care of the selected chargeCode"
      );
      this.handler.emit(this.selectedChargeCode);
    }
  }

  clearChargeCode() {
    this.selectedChargeCode = new ProjectChargeCode();
    this.cancelHandler.emit("ChargeCode Cancelled");
  }
}
